import React, { useState } from 'react';
import { Container, Box, Typography, Tabs, Tab } from '@mui/material';
import Login from '../components/Login';
// import Signup from '../components/SignUp'; // Assuming you have a similar SignupPage component

const AuthPage = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Container component="main" maxWidth="xs">

                <Login />

        </Container>
    );
};

export default AuthPage;
